const ALLOWED_TAGS = new Set([
  'a',
  'b',
  'br',
  'div',
  'em',
  'i',
  'li',
  'ol',
  'p',
  'span',
  'strong',
  'u',
  'ul',
]);

const DROP_WITH_CONTENT = new Set([
  'script',
  'style',
  'iframe',
  'object',
  'embed',
  'svg',
  'math',
  'template',
]);

const SAFE_URL_PATTERN = /^(https?:|mailto:|tel:|\/(?!\/)|#)/i;

const escapeHtml = value =>
  String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

const sanitizeElementAttributes = element => {
  [...element.attributes].forEach(attribute => {
    const name = attribute.name.toLowerCase();
    const value = attribute.value.trim();

    if (name.startsWith('on') || name === 'style') {
      element.removeAttribute(attribute.name);
      return;
    }

    if (element.tagName.toLowerCase() === 'a' && name === 'href') {
      if (SAFE_URL_PATTERN.test(value)) {
        element.setAttribute('rel', 'noopener noreferrer');
        return;
      }
    }

    element.removeAttribute(attribute.name);
  });
};

const sanitizeNode = node => {
  [...node.childNodes].forEach(child => {
    if (child.nodeType !== Node.ELEMENT_NODE) return;

    const tagName = child.tagName.toLowerCase();

    if (DROP_WITH_CONTENT.has(tagName)) {
      child.remove();
      return;
    }

    if (!ALLOWED_TAGS.has(tagName)) {
      sanitizeNode(child);
      child.replaceWith(...child.childNodes);
      return;
    }

    sanitizeElementAttributes(child);
    sanitizeNode(child);
  });
};

export const sanitizeHtml = html => {
  if (!html) return '';

  if (typeof DOMParser === 'undefined' || typeof Node === 'undefined') {
    return escapeHtml(html);
  }

  const doc = new DOMParser().parseFromString(String(html), 'text/html');
  sanitizeNode(doc.body);
  return doc.body.innerHTML;
};

export default sanitizeHtml;
